<template>
  <nav v-if="pages > 1" class="ui-pager" :aria-label="$t('Pagination')">
    <button
      type="button"
      class="ui-pager__arrow"
      :disabled="page <= 1"
      :aria-label="$t('Previous')"
      @click="emit('update:page', page - 1)"
    >
      <ChevronLeft :size="18" aria-hidden="true" />
    </button>

    <span class="ui-pager__label">
      {{ $t("Page {page} of {pages}", { page, pages }) }}
    </span>

    <button
      type="button"
      class="ui-pager__arrow"
      :disabled="page >= pages"
      :aria-label="$t('Next')"
      @click="emit('update:page', page + 1)"
    >
      <ChevronRight :size="18" aria-hidden="true" />
    </button>
  </nav>
</template>

<script setup lang="ts">
import { ChevronLeft, ChevronRight } from "lucide-vue-next";

defineProps<{
  page: number;
  pages: number;
}>();

const emit = defineEmits<{
  "update:page": [page: number];
}>();
</script>
